export default {"src":"/_next/static/media/notehub-guides.ca1644e8.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};